import { Question } from './Question';
import { Survey } from './Survey';
import { SecondaryReport } from './SecondaryReport';
import { Characteristic } from './Characteristic';
import { TeamologyClarity } from './TeamologyClarity';
import { HasId } from '../interfaces';

export class RFactor implements HasId {
    public id: number;
    public average: number;
    public stdDev: number;
}

export class GridOption implements HasId {
    public id: number;
    public name: string;
    public characteristicOne: Characteristic;
    public characteristicOneID: number;
    public characteristicTwo: Characteristic;
    public characteristicTwoID: number;
    public characteristicOneLabel: string;
    public characteristicTwoLabel: string;
    public surveyVersionID: number;
}

export class TeamGrid implements HasId {
    public id: number;
    public name: string;
    public quadrantOne: Characteristic;
    public quadrantOneID: number;
    public quadrantTwo: Characteristic;
    public quadrantTwoID: number;
    public quadrantThree: Characteristic;
    public quadrantThreeID: number;
    public quadrantFour: Characteristic;
    public quadrantFourID: number;
    public quadrantAccomadate: Characteristic;
    public quadrantAccomadateID: number;
}

export class SurveyVersion implements HasId {
    public id: number;
    public version: number;
    public nickname: string;
    public published?: Date;
    public active: boolean;

    public questions: Question[];
    public surveyID: number;
    public survey: Survey;
    public gridOptions: GridOption[];
    public secondaryReports: SecondaryReport[];
    public teamologyClarities: TeamologyClarity[];
    public teamGrids: TeamGrid[];
    public readynessCharacteristicID: number | undefined;
    public rFactor: RFactor;

    constructor() {
        this.questions = [];
    }
}


// WEBPACK FOOTER //
// ./src/models/SurveyVersion.tsx